import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import {
  INotificationQuery,
  INotificationQueryVariables,
} from '../../utils/apollo/graphqlSchema';
import { notificationUpdateAction } from '../../redux/actions/notifications';
import { collectAllUniqRolesFromUser } from '../../pages/PermissionControls/utils';
import { setUser } from '../../redux/slices/permission';
import notificationQuery from './notificationQuery';
import { NOTIFICATIONS_POLLING_INTERVAL } from '../../config/constants';
import { useAppDispatch } from '../../redux/hooks';
import { useBootstrapSelector } from '../../redux/selectorHooks';
import useUser from '../../utils/hooks/useUser';
import { batch } from 'react-redux';
import useBroadcastChannel from '../../utils/hooks/useBroadcastChannel';
import { MaybeNil } from '../../utils/interfaces';

const WsNotification = () => {
  const dispatch = useAppDispatch();
  const bootstrapLoaded = useBootstrapSelector('bootstrapLoaded');
  const user = useUser();

  const onCompleted = useCallback(
    ({ notification, user }: INotificationQuery) => {
      batch(() => {
        if (notification) {
          dispatch(notificationUpdateAction(notification));
        }

        // update roles from User.groups and User.roles into redux store for checking permissions
        const allUniqueRoles = collectAllUniqRolesFromUser(user);
        dispatch(setUser({ user, roles: allUniqueRoles }));
      });
    },
    [dispatch],
  );
  const { refetch } = useQuery<INotificationQuery, INotificationQueryVariables>(
    notificationQuery,
    {
      variables: {
        id: user.id,
      },
      pollInterval: NOTIFICATIONS_POLLING_INTERVAL,
      errorPolicy: 'ignore',
      skip: !bootstrapLoaded,
      onCompleted,
    },
  );

  // if there is change in Slack connection refetch user information
  // to get updated slack integration
  const messageHandler = useCallback(async () => {
    await refetch();
  }, [refetch]);

  useBroadcastChannel<MaybeNil<string>>({
    channelName: 'slack',
    messageHandler,
  });

  return null;
};

export default WsNotification;
